<template>
  <div>
    <el-dialog
      class="dialogPackage"
      :show-close="false"
      center
      :visible.sync="isShowDialog"
      :before-close="handleClose"
      :height="dialogMinHeight"
    >
      <div class="mb-20">
        <div style="position:relative;">
          <div style="padding-bottom: 0 !important;" class="container mt-3">
            <p class="title-dialog m-0">{{ $t("wap.text169") }}</p>
            <img @click="handleClose" :src="bg.icon_closed" alt="" />
          </div>
          <el-row style="padding-top: 16px;" class="full-width container">
            <el-col :xs="24" :sm="24" :md="24" :lg="24">
              <div class="full-width">
                <div
                  v-if="listPackage.length > 0"
                  class="full-width golfContainer"
                >
                  <div
                    v-for="item in listPackage"
                    class="golf-course align-items-center justify-content-between pb-10"
                    @click="handleActive(item)"
                    :key="item.id"
                    style="border-bottom: 0.81px solid var(--Border-Grey-Medium, #F6F6F6)"
                  >
                    <div class="d-flex align-items-center">
                      <img
                        class="mr-10"
                        style="height: 25px; width:25px; object-fill: cover; border-radius: 50%; "
                        src="@/assets/img/v3/icon/logo_insurance.svg"
                        alt=""
                      />
                      <div class="info-golf-course full-width">
                        <h3 class="name-course  c-text-main">
                          {{ item.name }}: {{ item.des }}
                        </h3>
                        <p class="address-course">
                          {{ $t("wap.text170") }} {{ item.text_display_sms }}
                        </p>
                      </div>
                    </div>
                    <div class="d-flex align-items-center">
                      <p style="color: #000;" class="m-0 c-tiny">
                        {{ formatNumber(item.price) }} đ
                      </p>
                      <div class="ml-5 mb-5" v-if="item.is_option">
                        <img
                          v-if="item.is_checked"
                          src="@/assets/img/v3/icon/checkbox_active.svg"
                          alt=""
                        />
                        <img
                          v-else
                          src="@/assets/img/v3/icon/checkbox_not_active.svg"
                          alt=""
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </el-col>
          </el-row>
        </div>
        <div class="footer-dialog-insurance">
          <button-customer
            :styles="{
              fontSize: '12px',
              fontWeight: 500,
              height: '30px',
              borderRadius: '5px',
              padding: '5px 0px'
            }"
            :object-data="{ title: $t('wap.text171') }"
            @on-action="handleAction"
          />
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getBackGround } from "@/utils/wapAuth";
import { formatNumber } from "@/plugins/init";
import GlobalAPI from "@/views/api/wapV2/global";
import { toggleChat } from "@/utils/helper";
import ButtonCustomer from "@/components/wapV2/button/index.vue";

export default {
  name: "dialogPackage",
  components: {
    ButtonCustomer
  },
  props: {
    isShowDialog: {
      type: Boolean,
      default: false
    },
    isViewsPrice: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      isLoading: false,
      listPackage: [],
      list_pack_use: [],
      bg: getBackGround(),
      isMobile: true,
      icons: {}
    };
  },
  created() {},

  computed: {
    dialogMinHeight() {
      return window.innerHeight * 0.9 + "px";
    }
  },
  watch: {
    isShowDialog: function(newValue, oldValue) {
      if (newValue) {
        this.hideOverflow();
        toggleChat(false);
        if (this.listPackage.length > 0) return;
        this.getListPackage();
      } else {
        toggleChat(true);
        this.showOverflow();
      }
    }
  },
  mounted() {},
  methods: {
    formatNumber,
    hideOverflow() {
      const dBody = document.body;
      if (!this.isViewsPrice) {
        dBody.style.position = "fixed";
        dBody.style.height = "100%";
        dBody.style.overflow = "hidden";
        dBody.style.width = "100%";
      }
    },
    showOverflow() {
      const dBody = document.body;
      dBody.style.position = "";
      dBody.style.height = "";
      dBody.style.width = "";
      dBody.style.overflow = "";

      document.documentElement.style.overflow = "";
    },
    handleActive(row) {
      if (row) {
        if (row.is_checked) {
          this.list_pack_use.splice(this.list_pack_use.indexOf(row), 1);
        } else {
          this.list_pack_use.push(row);
        }
        row.is_checked = !row.is_checked;
      }
    },
    getListPackage() {
      GlobalAPI.list_package({ type_pack: 1 })
        .then(res => {
          if (res.error_code === 0) {
            this.listPackage = res.data.map(i => ({
              ...i,
              is_option: true,
              is_checked: false
            }));
          } else {
            this.listPackage = [];
          }
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    handleAction() {
      this.$emit("item-ins", this.list_pack_use);
      this.handleClose();
    },
    handleClose() {
      this.$emit("close", true);
    }
  }
};
</script>
<style lang="scss">
$color_slider: v-bind("bg.c_button_main");
// $color_radio_check: v-bind("bg.c_inherit_text");
$color_radio_check: v-bind("bg.c_button_main");
$color_slider_bar: #d9d9d9;

.mt-15 {
  margin-top: 15px !important;
}
.mb-15 {
  margin-bottom: 15px !important;
}
.dialogPackage .el-dialog {
  position: relative;
  border-radius: 10px;
  min-height: 10vh;
  overflow: hidden;
  max-width: 500px !important;
  width: 100%;
  z-index: 2100;
  margin-bottom: 0 !important;
  margin-top: 10vh !important;

  .el-dialog__body {
    padding-top: 0 !important;
    padding-bottom: 0px !important;
    padding-left: 0 !important;
    padding-right: 0 !important;
  }

  .el-dialog__header {
    margin: 0;
    padding: 0;
  }
}
.el-tooltip__popper {
  display: none !important;
}

@media screen and (min-width: 0px) and (max-width: 600px) {
  .dialogPackage .el-dialog {
    position: fixed;
    bottom: 0;
    margin-top: 20vh !important;
    border-radius: 20px;
    overflow: hidden;
    max-width: 550px !important;
    width: 100%;
    height: 45vh;
    z-index: 2100;
    margin-bottom: 0 !important;
    border-bottom-left-radius: 0 !important;
    border-bottom-right-radius: 0 !important;
  }
}
@media screen and (min-width: 0px) and (max-width: 380px) {
  .dialogPackage .el-dialog {
    position: fixed;
    bottom: 0;
    margin-top: 10vh !important;
    border-radius: 30px;
    background: rgba(240, 241, 245, 1);
    height: 45vh;
    overflow: hidden;
    max-width: 550px !important;
    width: 100%;
    margin-bottom: 0 !important;
    z-index: 2100;

    border-bottom-left-radius: 0 !important;
    border-bottom-right-radius: 0 !important;
  }
}
@media screen and (max-width: 320px) and (max-height: 568px) {
  .dialogPackage .el-dialog {
    margin-top: 10vh !important; /* Giảm khoảng cách từ trên xuống */
    height: 45vh;
    bottom: 0;
    min-height: auto; /* Bỏ giá trị cố định cho chiều cao tối thiểu */
    max-height: none; /* Bỏ giới hạn chiều cao tối đa */
    max-width: 100% !important; /* Đặt chiều rộng tối đa là 100% */
    border-radius: 0; /* Loại bỏ viền bo tròn */
    z-index: 2100;
  }
}
</style>

<style lang="scss" scoped>
$divider-color: #ececec;

$color-btn: v-bind("bg.c_button_main");
.title-dialog {
  color: var(--Foreground-Ink-Default, #1a1a1a);

  font-weight: 600;
  font-size: 14.56px;
  line-height: 19.41px;
  letter-spacing: 0%;
}

.info-golf-course {
  position: relative;
  padding-right: 20px;
}
.address-course {
  color: #999999;
  font-size: 11px;
  margin: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  height: 20px;
}
.name-course {
  font-size: 12px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  margin: 0;
  font-weight: 500;
}
.golf-course {
  overflow: hidden;
  padding: 0;
  display: flex;
  margin-bottom: 10px;
}
.footer-dialog-insurance {
  background-color: #ffff;
  padding-bottom: 10px;
  height: 40px;
  position: absolute;
  bottom: 0;
  padding: 0px 10px;
  width: 100%;
}
.w-100 {
  width: 100%;
}
.mr-10 {
  margin-right: 10px;
}
</style>
